module.exports = __webpack_public_path__ + "static/media/PKL-Video.b7c89d57.mp4";